import './wishlist.css';
import LogoutIcon from './Images/logout.svg';
import React, { useEffect, useState } from "react";
import { products } from '../subcatigory/SubcardsSide/data'
import { useTranslation } from 'react-i18next'
import * as Wish from "../../network/api/wish";
import { getProductsOfCart } from '../../network/api/product';
import { CardWishlist } from './CardWishlist';
import { CartContext } from './Wishlistcontext';
import { update } from '../../network/api/personal_cookies';
import FreeWishlist from './free/FreeWishlist';

function Wishlist(props) {
  const { t } = useTranslation()
  const [wishItems, setWishItems] = useState([]);
  const [ProductItems, setProductItems] = useState([]);
  const [isEmpty, setIsEmpty] = useState(true);

  const load = async () => {
    const productArr = []
    const wishArr = await Wish.get_wish()
    if (wishArr?.length === 0) {
      setIsEmpty(true)
    } else {
      wishArr?.forEach(element => {
        productArr.push(element.product_id)
      });
      const products = await getProductsOfCart(productArr)
      setWishItems(wishArr)
      setProductItems(products)
      setIsEmpty(false)
      props.update_p()
    }
  }

  useEffect(() => {
    load()
  }, [isEmpty]);

  return (
    <div className='wishlist'>
      <div className='container'>
        <div className='head-title'>
          <p className='m-0'>{t("home")}</p>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5781 3.4001L7.14479 8.83343C6.50312 9.4751 6.50312 10.5251 7.14479 11.1668L12.5781 16.6001" stroke="#807D7E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <p className='m-0'>{t("favorites")}</p>
        </div>
        <div>
          {isEmpty ? (
            <FreeWishlist />
          ) : (
            <div className='row flex-wrap ' style={{ height: "fit-content" }}
            >
              {ProductItems?.map((product, index) => {
                return <>
                  {<CardWishlist
                    key={product._id}
                    product={product}
                    wish={wishItems[index]}
                    load={load}
                    update_p={props.update_p} />}</>
              })}
            </div >
          )}
        </div>
      </div>
    </div>
  )
}
export default Wishlist;